// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { BaseQuestionOption } from '.';

/**
 * @export
 * @interface BaseDefaultQuestionDisplay
 */
export interface BaseDefaultQuestionDisplay {
  /**
   * @type {number}
   * @memberof BaseDefaultQuestionDisplay
   */
  readonly id?: number;
  /**
   * @type {string}
   * @memberof BaseDefaultQuestionDisplay
   */
  text: string;
  /**
   * @type {string}
   * @memberof BaseDefaultQuestionDisplay
   */
  description?: string;
  /**
   * @type {string}
   * @memberof BaseDefaultQuestionDisplay
   */
  type?: BaseDefaultQuestionDisplayTypeEnum;
  /**
   * @type {Array<BaseQuestionOption>}
   * @memberof BaseDefaultQuestionDisplay
   */
  options?: Array<BaseQuestionOption>;
  /**
   * @type {string}
   * @memberof BaseDefaultQuestionDisplay
   */
  readonly slug?: string;
  /**
   * @type {boolean}
   * @memberof BaseDefaultQuestionDisplay
   */
  is_required?: boolean;
  /**
   * @type {boolean}
   * @memberof BaseDefaultQuestionDisplay
   */
  is_options_custom_text_allowed?: boolean;
  /**
   * @type {boolean}
   * @memberof BaseDefaultQuestionDisplay
   */
  editable?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum BaseDefaultQuestionDisplayTypeEnum {
  Single = 'single',
  Multiple = 'multiple',
  Paragraph = 'paragraph',
  Text = 'text',
  Custom = 'custom',
}
